import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  background-color: #f2f2f2;
  animation-name: ${({ clicked }) => (clicked ? 'dropdown' : 'rollup')};
  animation-duration: 400ms;
  animation-timing-function: linear;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;

  @keyframes dropdown {
    0% {
      height: 0;
    }
    100% {
      height: 26rem;
    }
  }

  @keyframes rollup {
    0% {
      height: 26rem;
    }
    100% {
      height: 0;
    }
  }

  @media (min-width: 62rem) {
    flex-flow: row wrap;
    justify-content: flex-start;
    animation-name: none;
    padding-top: 1.5rem;
    padding-left: 2rem;
    height: 11.25rem;
  }

  @media (min-width: 75rem) {
    flex-flow: row wrap;
    align-items: center;
    justify-content: center;
    animation-name: none;
    padding: 15px 0px;
    height: auto;
  }

  &.eventsearch_container {
    position: relative;

    @media (max-width: 1199.98px) and (min-width: 992px) {
      .event_input,
      .event_select {
        width: 180px;
      }

      .event_datepicker {
        width: 230px;
      }
    }

    div[class*='DatePickerstyled__DateContainer-'] {
      @media (max-width: 991.98px) {
        width: 300px;
      }
    }
  }
`;

export const Input = styled.input`
  height: 3.125rem;
  padding: 0.8125rem 1.25rem;
  font-size: 10px;
  text-transform: none;
  margin: 0.6rem 0;
  outline: none;
  border: none;
  width: 85%;

  &[dir='ltr'] {
    letter-spacing: 1.82px;
    font-family: 'DINRegular';
    text-transform: uppercase;
  }

  &[dir='rtl'] {
    font-family: inherit;
    @media (max-width: 1198.98px) {
      font-size: 16px;
      letter-spacing: 0;
      text-transform: none;
    }
  }

  @media (max-width: 1199.98px) {
    /* font-size: 16px; */
    letter-spacing: 0;
    text-transform: none;
  }

  display: ${({ clicked, delayShowUp }) => (clicked && delayShowUp ? 'flex' : 'none')};

  &:focus {
    outline: 3px solid #b5d4f5;
  }

  @media (min-width: 36rem) {
    width: 31.25rem;
  }

  @media (min-width: 48rem) {
    width: 42.5rem;
  }

  @media (min-width: 62rem) {
    display: flex;
    width: 245px;
    margin: 0 10px;
  }
`;
